import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import '../styles/subscription.css';
import { ALLOW_FREE_SUBSCRIPTION } from '../config';

const SubscriptionGate = ({ children }) => {
    const { user, loading } = useAuth();
    const navigate = useNavigate();

    if (loading) {
        return (
            <div className="loading-spinner">
                <div className="spinner"></div>
            </div>
        );
    }

    // Temporarily allow free access for hackathon
    return <>{children}</>;

    // Original subscription check logic (commented out for hackathon)
    /*
    if (ALLOW_FREE_SUBSCRIPTION === 'true') {
        return <>{children}</>;
    }

    // Check if user has active Pro subscription
    const hasProAccess = user?.subscription_plan === 'pro' &&
        user?.subscription_status === 'active';

    if (hasProAccess) {
        return <>{children}</>;
    }

    return (
        <div className="subscription-gate-overlay">
            <div className="subscription-gate-content">
                <div className="gate-icon">🔒</div>
                <h2>Pro Subscription Required</h2>
                <p>
                    You need an active Pro subscription to access this feature.
                    Unlock unlimited notebooks, AI chat, and advanced code execution.
                </p>
                <button
                    className="gate-button"
                    onClick={() => navigate('/subscription')}
                >
                    Subscribe to Pro
                </button>
            </div>
        </div>
    );
    */
};

export default SubscriptionGate;